import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { makeGroupsAccData } from '../../utils/balance-accounts';
import HeadquarterAccountsTable from '../../components/groups-accounts/HeadquarterAccountsTable';

const HeadquarterAccountsContainer = ({
  selectedYear,
  selectedHq,
  tableRef,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const onLoadData = () => {
    setLoading(true);
    const loadedData = makeGroupsAccData();
    setData(loadedData);
    setLoading(false);
  };

  useEffect(() => {
    onLoadData();
  }, [selectedYear, selectedHq]);

  const content = loading ? (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>
  ) : (
    <HeadquarterAccountsTable
      data={data || []}
      loading={loading}
      tableRef={tableRef}
    />
  );

  return content;
};

export default HeadquarterAccountsContainer;
